"use client";

import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const columnOneItems = ["Physician owners seeking clinical excellence and operational efficiency in their ASC.", "Health systems looking to optimize outpatient surgical portfolios and patient outcomes.", "Surgical specialists requiring high-performance environments for complex procedures.", "Independent practices aiming to transition to a physician-led surgery center model."];
const columnTwoItems = ["Facility administrators focused on regulatory compliance and revenue cycle management.", "Nursing leadership dedicated to maintaining the highest standards of patient safety.", "Real estate investors seeking stable, high-growth partnerships in the healthcare sector.", "Patients expecting personalized, high-quality care in a modern surgical setting."];
export default function WhoThisIsFor() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}